import { regionApi, RegionApi } from './region';

export { regionApi, RegionApi };



// WEBPACK FOOTER //
// ./src/api/region/index.ts